var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95163 14.4558C4.62744 14.4558 4.3586 14.187 4.3586 13.8628V12.226C4.3586 11.9019 4.62744 11.633 4.95163 11.633C5.27581 11.633 5.54465 11.9019 5.54465 12.226V13.8628C5.54465 14.1949 5.27581 14.4558 4.95163 14.4558Z",
    fill: "#721C31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.4558C8.67581 14.4558 8.40698 14.187 8.40698 13.8628V10.5814C8.40698 10.2572 8.67581 9.98837 9 9.98837C9.32419 9.98837 9.59302 10.2572 9.59302 10.5814V13.8628C9.59302 14.1949 9.32419 14.4558 9 14.4558Z",
    fill: "#721C31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0484 14.4558C12.7242 14.4558 12.4553 14.187 12.4553 13.8628V8.94465C12.4553 8.62047 12.7242 8.35163 13.0484 8.35163C13.3726 8.35163 13.6414 8.62047 13.6414 8.94465V13.8628C13.6414 14.1949 13.3805 14.4558 13.0484 14.4558Z",
    fill: "#721C31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95163 9.93302C4.68279 9.93302 4.44558 9.75116 4.37442 9.48233C4.29535 9.16605 4.48512 8.84186 4.8093 8.76279C7.71907 8.03535 10.2809 6.44605 12.234 4.17674L12.5977 3.74977C12.8112 3.50465 13.1828 3.47302 13.4358 3.68651C13.6809 3.9 13.7126 4.27163 13.4991 4.52465L13.1353 4.95163C11.0242 7.4186 8.24093 9.13442 5.09395 9.91721C5.04651 9.93302 4.99907 9.93302 4.95163 9.93302Z",
    fill: "#721C31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0484 7.03907C12.7242 7.03907 12.4553 6.77023 12.4553 6.44605V4.73023H10.7316C10.4074 4.73023 10.1386 4.4614 10.1386 4.13721C10.1386 3.81302 10.4074 3.54419 10.7316 3.54419H13.0484C13.3726 3.54419 13.6414 3.81302 13.6414 4.13721V6.45395C13.6414 6.77814 13.3805 7.03907 13.0484 7.03907Z",
    fill: "#721C31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3721 17.5H6.62791C2.33442 17.5 0.5 15.6656 0.5 11.3721V6.62791C0.5 2.33442 2.33442 0.5 6.62791 0.5H11.3721C15.6656 0.5 17.5 2.33442 17.5 6.62791V11.3721C17.5 15.6656 15.6656 17.5 11.3721 17.5ZM6.62791 1.68605C2.98279 1.68605 1.68605 2.98279 1.68605 6.62791V11.3721C1.68605 15.0172 2.98279 16.314 6.62791 16.314H11.3721C15.0172 16.314 16.314 15.0172 16.314 11.3721V6.62791C16.314 2.98279 15.0172 1.68605 11.3721 1.68605H6.62791Z",
    fill: "#721C31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisIcon);
export default __webpack_public_path__ + "static/media/analysis-icon.46390ceb144cb9170b22996a3ef18a22.svg";
export { ForwardRef as ReactComponent };